import { render, staticRenderFns } from "./pagination-new.vue?vue&type=template&id=b69598da&"
import script from "./pagination-new.vue?vue&type=script&lang=js&"
export * from "./pagination-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports